function modifyBtnNavToggle() {
  const navToggle = document.querySelector('.mobile-nav-toggle');

  navToggle.innerHTML = `
    <span></span>
    <span></span>
    <span></span>
  `;
  navToggle.setAttribute('tabindex', '0');
  navToggle.setAttribute('role', 'button');
  navToggle.setAttribute('aria-label', 'open menu');
}

function animateButtons() {
  const buttons = $('.button, .button-small, .moreButton');
  buttons.hover(
    function () {
      $(this).removeClass('animate-out').addClass('animate-in');
    },
    function () {
      $(this).removeClass('animate-in').addClass('animate-out');
    },
  );
}

// New
function featureLineupChange() {
  $('.featureLineupContainer').each(function () {
    const row_obj = this;
    const titles = $(row_obj).find('.subContainer').find('span.featureLineup-title').detach();
    const btns = $(row_obj).find('.featureLineup-buttons').find('.featureLineup-more').detach();
    const destext = $(row_obj)
      .find('.featureLineupImage a:eq(1)')
      .find('.featureLineup-text')
      .detach();

    $(row_obj).find('.subContainer').find('.featureLineupImage').prepend(titles);
    $(row_obj).find('.subContainer').find('.featureLineupImage').prepend(destext);
    $(row_obj).find('.subContainer').find('.featureLineupImage').append(btns);
  });
}
function featureLineupTitle() {
  $('.featureLineup-text').each(function () {
    const text = $(this).text();
    if (text.length > 140) {
      $(this).text(text.substring(0, 140) + '...');
    }
  });
}

function countdownShifted() {
  if ($('#body').hasClass('saffireMobileSize')) {
    $('.header .count-down-wrapper').insertAfter('#swiperWidget');
  } else {
    $('.swiper-main .count-down-wrapper').insertAfter('.saffireLargeSize .header-logo');
  }
}
function mobileWindow() {
  // Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 1080) {
    $('body').addClass('saffireMobileSize').removeClass('saffireLargeSize');
  }
  if (windowSize > 1079) {
    $('body').removeClass('saffireMobileSize');
  }
}

$(document).ready(() => {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');

  // Add empty class
  $('.FeatureLineupModule .featureLineupModule .featureLineup-social').each(function () {
    if ($(this).html().trim() == '') {
      $(this).addClass('is-empty');
    }
  });

  modifyBtnNavToggle();
  featureLineupChange();
  featureLineupTitle();
  mobileWindow();
  countdownShifted();
  animateButtons();
});

$(window).resize(() => {
  mobileWindow();
  countdownShifted();
});
